import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";

export default function AdminChangePassword() {
    const { logout } = useAuth();
    const nav = useNavigate();
    const [current, setCurrent] = useState("");
    const [next, setNext] = useState("");
    const [confirm, setConfirm] = useState("");
    const [saving, setSaving] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (next.length < 8) return toast.error("Minimum 8 characters");
        if (next !== confirm) return toast.error("New passwords do not match");
        if (next === current) return toast.error("New password must differ from current");
        setSaving(true);
        try {
            await api.post("/auth/change-password", { current_password: current, new_password: next });
            toast.success("Password updated. Please log in again.");
            logout();
            nav("/admin/login");
        } catch (e) {
            toast.error(e.response?.data?.detail || "Could not change password");
        } finally { setSaving(false); }
    };

    return (
        <div data-testid="admin-change-password">
            <h1 className="font-display text-4xl tracking-tighter mb-2">Change Password</h1>
            <p className="text-sm text-neutral-600 mb-6 max-w-lg">Set a strong password. Minimum 8 characters. Use a mix of letters, numbers, and symbols. You'll be logged out and asked to sign in again with the new one.</p>
            <form onSubmit={submit} className="bg-white border-2 border-black p-6 max-w-md space-y-4 brutal-shadow">
                <label className="block">
                    <div className="font-mono text-[10px] uppercase text-neutral-500 mb-1">Current Password</div>
                    <input type="password" required value={current} onChange={e => setCurrent(e.target.value)} className="w-full border-2 border-black p-3 font-mono" data-testid="cp-current" autoComplete="current-password" />
                </label>
                <label className="block">
                    <div className="font-mono text-[10px] uppercase text-neutral-500 mb-1">New Password (min 8)</div>
                    <input type="password" required minLength={8} value={next} onChange={e => setNext(e.target.value)} className="w-full border-2 border-black p-3 font-mono" data-testid="cp-new" autoComplete="new-password" />
                </label>
                <label className="block">
                    <div className="font-mono text-[10px] uppercase text-neutral-500 mb-1">Confirm New Password</div>
                    <input type="password" required minLength={8} value={confirm} onChange={e => setConfirm(e.target.value)} className="w-full border-2 border-black p-3 font-mono" data-testid="cp-confirm" autoComplete="new-password" />
                </label>
                <button type="submit" disabled={saving} className="w-full bg-black text-white py-3 font-mono uppercase text-xs tracking-widest" data-testid="cp-submit">
                    {saving ? "Updating…" : "Update Password"}
                </button>
            </form>
        </div>
    );
}
